module.exports = __webpack_public_path__ + "static/hipsterSizes-1ce6ff12d3c0b5783fc057eed5b98667.png";